/**
 * Which side is the hub, in the one wording the whole app uses.
 *
 * The seller picks this once during onboarding and it decides everything
 * afterwards — which way products travel, which screens are worth showing,
 * what the activity log means by "synced". It was written out separately in
 * onboarding and in settings, and the dashboard, which branches on it in a
 * dozen places, never actually said what it was. So the one setting the
 * whole app is arranged around was the one thing never on screen.
 *
 * One table, so a third phrasing cannot appear in a fourth place.
 *
 * `two_way` is not offered any more — onboarding asks for one of the two
 * directions — but shops that predate that question still hold it, and it
 * must read as something rather than as a blank.
 */
export const SYNC_SOURCES = {
  shopify: {
    id:    'shopify',
    label: 'Shopify → eBay',
    from:  'Shopify',
    to:    'eBay',
    short: 'Shopify is your hub',
    sub:   'Shopify is your hub. You manage products in Shopify and they list on eBay.',
  },
  ebay: {
    id:    'ebay',
    label: 'eBay → Shopify',
    from:  'eBay',
    to:    'Shopify',
    short: 'eBay is your hub',
    sub:   'eBay is your hub. You manage listings on eBay and they appear in Shopify.',
  },
  two_way: {
    id:    'two_way',
    label: 'Both directions',
    from:  'Shopify',
    to:    'eBay',
    short: 'Both directions',
    sub:   'Changes travel both ways between Shopify and eBay.',
  },
}

/**
 * The entry for a stored value, never undefined.
 *
 * A shop whose settings have not loaded yet, or one holding something this
 * build does not know about, still has to render — and a dashboard header
 * reading "undefined → undefined" is worse than one saying nothing.
 */
export function syncSourceInfo(value) {
  return SYNC_SOURCES[String(value || '')] || null
}

/** Just the direction, for a heading or a badge. */
export function syncSourceLabel(value) {
  return syncSourceInfo(value)?.label || null
}
